import * as React from 'react'
import logo from '../static/images/New_logo.jpg'

import { UserOutlined } from '@ant-design/icons'

import { Link, BrowserRouter as Router } from 'react-router-dom'

import { Menu, Input, Avatar, Badge, Select, Icon } from 'antd'
import apiRequest from '../hooks/ApiRequest'
import Notifications from '../pages/Notification/NotificationList'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min'

const SubMenu = Menu.SubMenu

const Search = Input.Search

const trgLogout = () => {
  localStorage.clear()
  window.location.href = '/'
}

class HeaderDiv extends React.Component {
  constructor() {
    super()
    this.state = {
      current: 'search',
      rtl: true,
      user: localStorage.getItem('username'),
      productName: localStorage.getItem('productName'),
      productId: localStorage.getItem('productId'),
      productList: [],
      role: JSON.parse(localStorage.getItem('roles')),
      loggedInUserID: parseInt(localStorage.getItem('loggedInUserID')),
    }
    this.sidebarToggle = this.sidebarToggle.bind(this)
  }

  async componentDidMount() {

let finalResult = [];

    if (this.state.role === 'InsurerAdmin') {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurerProductByInsurerId/${this.state.loggedInUserID}`,
        'GET'
      )

      if (response.success) {
        let result = response?.data.map(item => ({
          productid: item.genericProductId,
          productname: item.productName,
        }));
        finalResult = result;
        this.setState({ productList: result })
      }
      else {
        this.setState({ loading: false });
      }
    }
    else if (this.state.role === 'Broker') {
      const brokerPayload = [parseInt(this.state.loggedInUserID)];
      const insurerRes = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/GetInsurersByBrokerId`,
        'POST',
        brokerPayload
      );

      if (insurerRes.success && insurerRes?.data?.length > 0) {
        debugger;
        const insurerIDs = insurerRes.data.map(x => x.id);
        const response = await apiRequest(
          `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurerProductByInsurerIds`,
          'POST',
          insurerIDs
        );

        if (response.success) {
          debugger;
          let result = response?.data.map(item => ({
            productid: item.genericProductId,
            productname: item.productName,
          }));
          finalResult = result;
          this.setState({ productList: result })
        }

      }
    }
    else {
      const response = await apiRequest(process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts', 'GET');

      if (response.success) {
        finalResult = response?.data?.data;
        this.setState({ productList: response?.data?.data })
      }
      else {
        this.setState({ loading: false });
      }
    }

    // console.log(this.state.productList)

    const productName =
      finalResult?.find(
        p => p.productid === parseInt(this.state.productId, 10),
      )?.productname || 'Select Product'

    this.state.productName = productName

    localStorage.setItem('productName', this.state.productName)
  }

  sidebarToggle() {
    this.setState({
      rtl: !this.state.rtl,
    })
    var body = document.body
    body.classList.toggle('rtl')
  }

  handleClick = e => {
    console.log('click ', e)
    this.setState({
      current: e.key,
    })
  }
  handleSelectProduct = value => {
    const selectedProduct = this.state.productList.find(
      p => p.productid === value,
    )
    if (selectedProduct) {
      localStorage.setItem('productName', selectedProduct.productname)
      localStorage.setItem('productId', value)
      this.setState({ productName: selectedProduct.productname }, () => {
        this.props.history.push('/dashboard')
        window.location.reload();
      })
    }
  }

  render() {
    const classBox = `primaryBg box`

    return (
      <Menu
        key="header"
        mode="horizontal"
        theme="dark"
        className="d-flex align-items-center custom-navigation">
        <Menu.Item key="brand-logo" className="brand-logo">
          <Link to="/home">
            <img src={logo} className="logo-img" />
          </Link>
        </Menu.Item>
        {window.innerWidth > 800 && (
          <div onClick={this.props.toggleSidebar} className="sidebar-toggle">
            <Icon type="menu-fold" style={{ color: 'white' }} />
          </div>
        )}
        <div
          style={{
            marginLeft: 'auto',
            paddingRight: '1rem',
            display: 'flex',
            alignItems: 'center',
          }}>
          <Menu.Item key="brand-logo" className="brand-logo">
            <label style={{ fontWeight: 500, marginBottom: 5, marginRight: 5 }}>
              Select Product :
            </label>
            <Select
              placeholder="Select Product"
              value={this.state.productName || undefined}
              style={{ width: 200 }}
              onChange={value => {
                this.handleSelectProduct(value)
              }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }>
              {this.state.productList.map(product => (
                <Select.Option
                  key={product.productid}
                  value={product.productid}>
                  {product.productname}
                </Select.Option>
              ))}
            </Select>
          </Menu.Item>
        </div>

        <Menu.Item key="brand-logo" className="brand-logo">
          <Notifications />
        </Menu.Item>
        <SubMenu
          key="profile"
          title={
            <span>
              <div className="avatar-profile">
                <Avatar size={32} icon={<UserOutlined />} />
                <span
                  style={{
                    fontSize: '12px',
                    fontWeight: '500',
                    height: '28px',
                    color: 'black',
                  }}>
                  {' '}
                  {this.state.user}
                </span>
              </div>
            </span>
          }
          className="avatar-round ">
          <Menu.Item key="logout">
            <div
              onClick={() => {
                trgLogout()
              }}>
              Logout
            </div>
          </Menu.Item>
        </SubMenu>
      </Menu>
    )
  }
}
// export default HeaderDiv
export default withRouter(HeaderDiv)
